import { CellChange, Column, WorksheetInstance } from "jspreadsheet-ce";

export const useSheetEvents = () => {
  const onafterchanges = (
    instance: WorksheetInstance,
    changes: CellChange[],
  ) => {
    changes.forEach((_) => {
      instance.undo();
    });
  };
  const oncreateeditor = (
    instance: WorksheetInstance,
    td: HTMLTableCellElement,
    colIndex: number,
    rowIndex: number,
    input: null,
    options: Column,
  ) => {
    requestAnimationFrame(() => {
      const el = document.querySelector(".jeditor") as HTMLDivElement | null;
      if (el) el.contentEditable = "false";
    });
  };

  return {
    onafterchanges,
    onchange,
    oncreateeditor,
  };
};
